import React, { useState, useEffect } from "react";
import { Select, DatePicker, Space } from 'antd';

import LocationAutoSelectSearch from "components/location/forms/location-autoselect-search";
import { gqlBuilderWhere } from "utils";


const { Option } = Select;
const { RangePicker } = DatePicker;

const NoticeFiltersHelper = ( { setFilters } ) => {

    const [ filterList, setFilterList ] = useState({
        status : {},
        locationId : {},
        createDate : {},
    });

    useEffect( () => {
        setFilters( gqlBuilderWhere( filterList ) );
    }, [filterList, setFilters] );


    return (
        <>
            <LocationAutoSelectSearch 
                onSelect={ (value) => {
                    setFilterList( { 
                        ...filterList,
                        locationId : {
                            column: "LOCATION_ID",
                            operator: "EQ",
                            value: value
                        },
                    })
                }} 
                onClear={ () => {
                    setFilterList( { 
                        ...filterList,
                        locationId : {},
                    })
                }}
            />

            <Select
                className="select-notice-status"
                onSelect={ ( value ) => {

                    if( value !== 'all' ){

                        setFilterList( { 
                            ...filterList,
                            status : {
                                column: "STATUS",
                                operator: "EQ",
                                value: value
                            },
                        })

                    } else {

                        setFilterList( { 
                            ...filterList,
                            status : {},
                        })

                    }
                }}
                placeholder="Select Status"
                allowClear={ true }
                onClear={ () => {
                    setFilterList( { 
                        ...filterList,
                        status : {},
                    })
                }}
            >
                <Option value="new">New</Option>
                <Option value="approved">Approved</Option>
                <Option value="declined">Declined</Option>
            </Select>

            <div>
                <span className="me-2">Between date :</span>
                <Space direction="vertical" size={12}>
                    <RangePicker 
                        onChange={ (dates, dateSrings) => {

                            if( dateSrings[0] && dateSrings[1] ){

                                dateSrings[0] = dateSrings[0] + ' 00:00:00';
                                dateSrings[1] = dateSrings[1] + ' 23:59:59';

                                setFilterList( { 
                                    ...filterList,
                                    createDate : {
                                        column: "CREATED_AT",
                                        operator: "BETWEEN",
                                        value: dateSrings
                                    },
                                })

                            } else {

                                setFilterList( { 
                                    ...filterList,
                                    createDate : {},
                                })

                            }
                            
                        }} 
                    />
                </Space>
            </div>

        </>
    );

};

export default NoticeFiltersHelper